import React, { Component } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import Header from "./header";
class Intro extends Component {
    render() {
        return (
            <>
                <div id="intro-container">
                    <Header
                        {...this.props}
                    />
                    <div className="intro-wrapper">
                        <div className="d-flex">
                            <div data-aos="zoom-out-down">
                                <h5 className="heading6 green">Hi, my name is </h5>
                                <div className="ms-3">
                                    <h1 className="heading1 heading-name">AMAN GUPTA</h1>
                                    <h2 className="heading2 gray">Product-focused Fullstack Developer</h2>
                                    <p className="intro1-para">I am a building-focused software engineer. I'm now working on frontend and backend development for <a href="https://www.invock.com/" className="green" target="_blank" rel="noopener noreferrer">Invock Digital</a>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex justify-content-center"}>
                        <MdKeyboardArrowDown style={{ fill: "#EE767D" }} size={25} />
                        <span className={"ml-2"}>Scroll Down</span>
                    </div>
                </div>
            </>
        )
    }
}
export default Intro;